import React from 'react';
import { ABLE_COLORS } from '../constants';

/**
 * SegmentedControl - Reusable pill-style toggle
 *
 * @param {Array} options  - [{ key, label, icon? }]
 * @param {string} value   - Currently active key
 * @param {function} onChange - Called with the selected key
 * @param {'pill'|'button'} variant - Visual style (default: 'pill')
 */
export default function SegmentedControl({ options, value, onChange, variant = 'pill' }) {
  if (variant === 'button') {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        {options.map(({ key, label, icon: Icon }) => {
          const isActive = value === key;
          return (
            <button
              key={key}
              onClick={() => onChange(key)}
              style={{
                background: isActive ? ABLE_COLORS.accent : 'transparent',
                color: isActive ? 'white' : ABLE_COLORS.textSecondary,
                border: isActive ? 'none' : `2px solid ${ABLE_COLORS.border}`,
                borderRadius: ABLE_COLORS.radiusSmall,
                cursor: 'pointer',
                padding: '8px 16px',
                fontWeight: '600',
                fontSize: '14px',
                transition: 'all 0.15s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              {Icon && <Icon size={16} />}
              {label}
            </button>
          );
        })}
      </div>
    );
  }

  // Default: pill variant
  return (
    <div style={{
      display: 'inline-flex',
      background: ABLE_COLORS.bgSubtle,
      borderRadius: ABLE_COLORS.radiusMedium,
      padding: '4px',
      gap: '4px',
    }}>
      {options.map(({ key, label, icon: Icon }) => {
        const isActive = value === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 16px',
              border: 'none',
              borderRadius: ABLE_COLORS.radiusSmall,
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              background: isActive ? ABLE_COLORS.neutral : 'transparent',
              color: isActive ? ABLE_COLORS.primary : ABLE_COLORS.textMuted,
              boxShadow: isActive ? ABLE_COLORS.cardShadow : 'none',
              transition: 'all 0.15s ease',
            }}
          >
            {Icon && <Icon size={16} />}
            {label}
          </button>
        );
      })}
    </div>
  );
}
